import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Home from './components/Home/Home';
import Destination from './components/Destination/Destination';
import Blog from './components/Blog/Blog';
import Contact from './components/Contact/Contact';
import Navbar from './components/Navbar/Navbar';
import LogIn from './components/LogIn/LogIn';
import styled from 'styled-components';
import Signup from './components/Signup/Signup';
import ProtectedRoute from './utils/ProtectedRoute';

function App() {
	return (
		<Wrapper>
			<Navbar />
			<Switch>
				<Route path='/' exact component={Home} />
				<ProtectedRoute path='/destination' component={Destination} />
				<ProtectedRoute path='/blog' component={Blog} />
				<ProtectedRoute path='/contact' component={Contact} />
				<Route path='/login' component={LogIn} />
				<Route path='/signup' component={Signup} />
			</Switch>
		</Wrapper>
	);
}

export default App;

const Wrapper = styled.div``;
